import {
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import useToast from "../../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import AppButton from "../../../shares/AppButton";
import StandardSkeletoon from "../../../shares/loader/StandardSkeletoon";
import { AssociationService } from "../../../../../service/AssociationService";
import { AssociationCandidatService } from "../../../../../service/AssociationCandidatService";
import ResumerReponseList from "./ResumerReponseList";
import SearchIcon from "@mui/icons-material/Search";
import {
  AddOutlined,
  CheckOutlined,
  CloudDownloadOutlined,
  EditOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
} from "@material-ui/icons";
import { DownloadOutlined } from "@mui/icons-material";
import useConfirm from "../../../../../hooks/useConfirm";

const PriorisationDialogForm = ({ open, onFormClose, onFormOpen, idOffre }) => {
  const [associations, setAssociations] = useState([]);
  const [filteredAssociations, setFilteredAssociations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAssociation, setSelectedAssociation] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const [noteEditMode, setNoteEditMode] = useState(false);
  const [loadingChangeNote, setLoadingChangeNote] = useState(false);
  const [associationNote, setAssociationNote] = useState(
    selectedAssociation ? selectedAssociation.asso_note : 0
  );
  const [oldAssociationNote, setOldAssociationNote] = useState(
    selectedAssociation ? selectedAssociation.asso_note : 0
  );
  const [downloadingPj, setDownloadingPj] = useState(false);
  const [downloadExcel, setDownloadExcel] = useState(0);
  const [refreshReponse, setRefreshReponse] = useState(0);
  const { Toast, showToast } = useToast();

  const handleFormClose = () => {
    onFormClose();
    setDownloadExcel(0);
    setAssociations([]);
    setFilteredAssociations([]);
  };

  const handleGiveAssociationNote = (note) => {
    if (
      noteEditMode &&
      associationNote &&
      associationNote >= 0 &&
      selectedAssociation.id_ext_association
    ) {
      setLoadingChangeNote(true);
      AssociationCandidatService.updateAssociationCandidat({
        id_ext_asso_candidat: selectedAssociation.id_ext_asso_candidat,
        asso_note: note,
      })
        .then((res) => {
          if (res && res.success) {
            showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
            handleExecOnNoteChange();
            setOldAssociationNote(associationNote);
            // setNoteEditMode(false);
          } else {
            showToast(
              TYPE_NOTIFICATION.ERROR,
              res.message || "Erreur lors de la mise à jour de la note"
            );
            // setNoteEditMode(true);
          }
        })

        .finally(() => {
          setLoadingChangeNote(false);
        });
    } else {
      showToast(
        TYPE_NOTIFICATION.WARNING,
        "La note doit être un nombre positive"
      );
    }
  };

  const handleFilterAssociation = (value) => {
    const filtered = associations.filter((asso) =>
      asso.association_nom.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredAssociations(filtered);
  };

  const handleRefreshReponse = () => {
    setRefreshReponse(refreshReponse + 1);
  };

  const handleConfirmDownloadPj = (row) => {
    openConfirmDialog(
      "Telechargement des Fichiers",
      "Voullez-vous telecharger les fichiers envoyés par cette association?",
      () => handleDownloadAssociationPj(row)
    );
  };

  const handleDownloadAssociationPj = (row) => {
    setDownloadingPj(true);
    AssociationCandidatService.downloadUploadedFileByAssociation({
      id_ext_association: row.id_ext_association,
      id_type: idOffre,
    })
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            row.association_nom + " au lot " + row.libelle_type + ".zip"
          );
          document.body.appendChild(link);
          link.click();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
        }
      })
      .catch((error) => {
        showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
      })
      .finally(() => {
        setDownloadingPj(false);
      });
  };

  const handleExecOnNoteChange = () => {
    handleFetchAllAssociation(false);
  };

  const handleFetchAllAssociation = (loading = true) => {
    setFormLoading(loading);
    AssociationCandidatService.getAssociationCandidatureByType({
      id_type: idOffre,
    })
      .then((res) => {
        if (res && res.data) {
          setFilteredAssociations(res.data);
          setAssociations(res.data);
        }
      })
      .then(() => {
        setFormLoading(false);
      });
  };

  const handleSelectAssociation = (association) => {
    setSelectedAssociation(association);
  };

  const handleSave = () => {
    if (idOffre) {
      handleUpdate();
    } else {
      handleInsert();
    }
  };
  const handleInsert = () => {
    setLoading(true);
    AssociationService.insert(associations)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleUpdate = () => {
    setLoading(true);
    AssociationService.update(associations)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownloadExcel = () => {
    setDownloadExcel(downloadExcel + 1);
  };

  useEffect(() => {
    if (
      associationNote !== oldAssociationNote &&
      selectedAssociation.id_ext_association
    ) {
      setNoteEditMode(true);
    }
  }, [associationNote]);

  useEffect(() => {
    if (selectedAssociation && selectedAssociation.asso_note) {
      setAssociationNote(selectedAssociation.asso_note);
      setOldAssociationNote(selectedAssociation.asso_note);
    }
  }, [selectedAssociation]);

  useEffect(() => {
    if (open) {
      handleFetchAllAssociation();
    }
  }, [open]);

  return (
    <>
      <DialogComponent />
      <Dialog
        open={open}
        /* onClose={handleFormClose} */ fullWidth
        maxWidth="xl"
      >
        <Toast />
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader title={"Reordonner association"} />
            <CardContent>
              <Grid item width={"100%"} display={formLoading ? "" : "none"}>
                <StandardSkeletoon
                  show={formLoading}
                  row={4}
                  col={1}
                  escalier={true}
                  m={2}
                />
              </Grid>
              <Grid container display={formLoading ? "none" : ""} spacing={1}>
                <Grid item p={1} xs={12} lg={6}>
                  <CardHeader
                    sx={{ mb: -2 }}
                    avatar={
                      <>
                        <Grid
                          item
                          alignContent="center"
                          mr={1}
                          display={"none"}
                        >
                          <Button
                            title="Donner de note pour ordonner les associations"
                            color="primary"
                            size="small"
                            variant="contained"
                            startIcon={<AddOutlined />}
                            onClick={() => setNoteEditMode(true)}
                          >
                            Donner note
                          </Button>
                        </Grid>
                        <Grid item /* display={noteEditMode ? "" : "none"} */>
                          <TextField
                            id="recherche"
                            fullWidth
                            size="small"
                            onChange={(e) =>
                              handleFilterAssociation(e.target.value)
                            }
                            placeholder="Recherche"
                            InputProps={{
                              endAdornment: (
                                <IconButton>
                                  <SearchIcon />
                                </IconButton>
                              ),
                            }}
                          />
                        </Grid>
                      </>
                    }
                  />
                  <CardHeader
                    title={`Liste des associations (${associations.length})`}
                    titleTypographyProps={{ variant: "h6" }}
                    sx={{ mb: -2 }}
                  />
                  <Grid
                    item
                    maxHeight={"55vh"}
                    height={"55vh"}
                    overflow={"auto"}
                  >
                    {filteredAssociations.map((item, idx) => {
                      return (
                        <>
                          <Grid
                            onClick={() => handleSelectAssociation(item)}
                            sx={{
                              cursor: "pointer",
                              ...(item.id_ext_asso_candidat ===
                              selectedAssociation.id_ext_asso_candidat
                                ? {
                                    backgroundImage:
                                      "linear-gradient(to right, #f4f7fcff, #e7f1feff)",
                                    border: "1px solid gray",
                                    borderRadius: "5px",
                                    outline: "none", // Remove default browser outline
                                    transition:
                                      "border-color 0.3s, background-color 0.3s",
                                  }
                                : {}),
                            }}
                            container
                            p={2}
                            alignItems={"center"}
                            // spacing={2}
                            key={idx}
                          >
                            <Grid
                              item
                              xs={11}
                              display={"flex"}
                              alignItems={"center"}
                            >
                              <Grid mr={1}>
                                <Chip
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  label={`N° ${idx + 1} | Note = ${item.asso_note || 0}`}
                                />
                              </Grid>
                              <Grid item>{item.association_nom}</Grid>
                            </Grid>
                            <Grid item xs={1}>
                              <IconButton
                                color="primary"
                                onClick={() => handleSelectAssociation(item)}
                                title="Afficher reponses"
                              >
                                <RemoveRedEyeOutlined />
                              </IconButton>
                            </Grid>
                          </Grid>
                          <Divider variant="middle" />
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid item p={1} xs={12} lg={6}>
                  <CardHeader
                    sx={{ mb: -2 }}
                    avatar={
                      <>
                        <Grid
                          item
                          alignContent="center"
                          mr={1}
                          display={"none"}
                        >
                          <Button
                            title="Donner de note pour ordonner les associations"
                            color="primary"
                            size="small"
                            variant="contained"
                            startIcon={<AddOutlined />}
                            onClick={() => setNoteEditMode(true)}
                          >
                            Donner note
                          </Button>
                        </Grid>
                        <Grid item /* display={noteEditMode ? "" : "none"} */>
                          <TextField
                            sx={{ width: "150px", mr: 1, textAlign: "center" }}
                            title="Note "
                            label="Note "
                            error={!associationNote || associationNote < 0}
                            helperText={
                              !associationNote || associationNote < 0
                                ? "La note est requis"
                                : ""
                            }
                            value={associationNote}
                            onChange={(e) => setAssociationNote(e.target.value)}
                            variant="outlined"
                            size="small"
                            type="number"
                            InputProps={{
                              endAdornment: (
                                <IconButton
                                  loading={loadingChangeNote}
                                  color="success"
                                  size="small"
                                  sx={{
                                    display:
                                      associationNote === oldAssociationNote ||
                                      associationNote === 0 ||
                                      associationNote === null ||
                                      associationNote === ""
                                        ? "none"
                                        : "",
                                  }}
                                  onClick={(e) =>
                                    handleGiveAssociationNote(associationNote)
                                  }
                                >
                                  {noteEditMode ? (
                                    <CheckOutlined color="success" />
                                  ) : (
                                    <EditOutlined />
                                  )}
                                </IconButton>
                              ),
                            }}
                          />
                        </Grid>
                      </>
                    }
                    action={
                      <Grid container spacing={2} justifyContent="space-around">
                        <Grid item justifyContent={"center"}>
                          <IconButton
                            title="Telecharger les pieces jointes"
                            color="primary"
                            onClick={(e) =>
                              handleConfirmDownloadPj(selectedAssociation)
                            }
                            loading={downloadingPj}
                          >
                            <CloudDownloadOutlined />
                          </IconButton>
                        </Grid>
                        <Grid item>
                          <IconButton
                            title="Exporter en excel les reponses"
                            color="primary"
                            onClick={handleDownloadExcel}
                          >
                            <DownloadOutlined />
                          </IconButton>
                        </Grid>
                        <Grid item>
                          <IconButton
                            title="Actualiser"
                            color="primary"
                            onClick={handleRefreshReponse}
                          >
                            <RefreshOutlined />
                          </IconButton>
                        </Grid>
                      </Grid>
                    }
                  />
                  <CardHeader
                    title={`Résumé des réponses de l'association`}
                    titleTypographyProps={{ variant: "h6" }}
                    sx={{ mb: -2 }}
                  />
                  <ResumerReponseList
                    association={selectedAssociation}
                    onNoteUpdated={handleExecOnNoteChange}
                    downloadExcel={downloadExcel}
                    refresh={refreshReponse}
                    id_type={idOffre}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                text={"Fermer"}
                size={"medium"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default PriorisationDialogForm;
